import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import PropTypes from "prop-types";
import InviaDiNuovoEmailFirstStep from "./invia-di-nuovo-email-first-step/InviaDiNuovoEmailFirstStep";
import {useMemo, useState} from "react";
import InviaNuovoEmailDialogActions from "./invia-nuovo-email-dialog-actions/InviaNuovoEmailDialogActions";
import {Typography} from "@material-ui/core";
import {replacePlus39ESim} from "../../../../../../shared/utils/utils";
import InviaNuovoEmailSecondStep from "./invia-nuovo-email-second-step/InviaNuovoEmailSecondStep";
import CreazionePasswordStep
    from "../../../sim/Dialogs/distribuzione-digitale-esim-dialog/creazione-password-step/CreazionePasswordStep";
import StepRiepilogoESim
    from "../../../sim/Dialogs/importa-distribuzione-digitale-eSIM-dialog/step-riepilogo-esim/StepRiepilogoESim";
import {distribuzioneEsim} from "../../../../../../store/e-sim/actions";
import {useDispatch, useSelector} from "react-redux";
import Button from "@material-ui/core/Button";
import {validateEmail} from "../../../../../../shared/utils/regexUtils";

const InviaNuovoEmailDialgo = (props) => {
    const dispatch = useDispatch()
    const integrationId = useSelector(state => state.authReducer.selectedCompany.integrationId)
    const [step, setStep] = useState(0)
    const [newTableData, setNewTableData] = useState(replacePlus39ESim(props.selectedRows))
    const [hasError, setHasError] = useState(false)
    const [passwords, setPasswords] = useState({
        first: "",
        confirm: ""
    })
    const [emailReferente, setEmailReferente] = useState("")
    const [emailReferenteError, setEmailReferenteError] = useState(false)
    const loadingDistribuzioneEsim = useSelector(state => state.eSimReducer.distribuzioneEsimLoading);

    const handleSetStep = (step) => setStep(step)

    const handlePasswordChange = (e) => {
        setPasswords((oldPasswords) => ({...oldPasswords, [e.target.name]: e.target.value}))
    }

    const isPasswordValidFormat = useMemo(() => (
        /^(?=.*\d)(?=.*[!?#*%&$])(?=.*[a-z])(?=.*[A-Z]).{8,30}$/.test(passwords.first)
    ), [passwords.first])

    const handleClickConferma = () => {
        const distribuzioneList = newTableData.map((item) => (
            {
                eSimSelezionate: item.numeroDiTelefono ? item.numeroDiTelefono : item.seriale,
                emailAssociata: item.indirizzoEmail
            }
        ))
        const dtoBody = {
            integrationId,
            emailReferente,
            distribuzioneList,
            password: passwords.first
        }
        dispatch(distribuzioneEsim(dtoBody, handleSetStep))
    }

    const handleChiudiClick = () => {
        props.fetchTableData()
        props.setIsInviaNuovoEmailOpen(false)
    }

    const steps = {
        0: {
            title: `Invia di nuovo email - ${props.selectedRows.length} eSIM selezionate`,
            content: <InviaDiNuovoEmailFirstStep tableData={newTableData}
                                                 setNewTableData={setNewTableData}
                                                 hasError={hasError}
                                                 setHasError={setHasError}/>,
            actions: <InviaNuovoEmailDialogActions backButtonText={'annulla'}
                                                   nextButtonText={'prosegui'}
                                                   onClickBackButton={() => props.setIsInviaNuovoEmailOpen(false)}
                                                   onClickNextButton={() => handleSetStep(1)}
                                                   disabled={hasError}/>
        },
        1: {
            title: `Riepilogo invio email - ${props.selectedRows.length} eSIM selezionate`,
            content: <InviaNuovoEmailSecondStep tableData={newTableData}/>,
            actions: <InviaNuovoEmailDialogActions backButtonText={'indietro'}
                                                   nextButtonText={'conferma'}
                                                   onClickBackButton={() => handleSetStep(0)}
                                                   onClickNextButton={() => handleSetStep(2)}/>
        },
        2: {
            title: `Creazione Password - ${props.selectedRows.length} eSIM selezionate`,
            content: <CreazionePasswordStep
                handlePasswordChange={handlePasswordChange}
                isPasswordValidFormat={isPasswordValidFormat}
                passwords={passwords}/>,
            actions: <InviaNuovoEmailDialogActions backButtonText={'indietro'}
                                                   nextButtonText={'conferma'}
                                                   onClickBackButton={() => handleSetStep(1)}
                                                   onClickNextButton={() => handleSetStep(3)}
                                                   disabled={!(isPasswordValidFormat && (passwords.first === passwords.confirm))}/>
        },
        3: {
            title: `Riepilogo distribuzione digitale eSIM`,
            content: <StepRiepilogoESim emailReferenteError={emailReferenteError}
                                        setEmailReferenteError={setEmailReferenteError}
                                        emailReferente={emailReferente}
                                        password={passwords.first}
                                        setEmailReferente={setEmailReferente}/>,
            actions: <InviaNuovoEmailDialogActions backButtonText={'indietro'}
                                                   nextButtonText={'conferma'}
                                                   onClickBackButton={() => handleSetStep(2)}
                                                   onClickNextButton={() => handleClickConferma()}
                                                   loading={loadingDistribuzioneEsim}
                                                   disabled={!validateEmail(emailReferente)}/>
        },
        4: {
            title: `Invio email`,
            content: <Typography variant='body2'>Abbiamo preso in carico la tua richiesta, consulta maggiori dettagli
                nella <span style={{textDecoration: "underline"}}>sezione notifiche</span> per
                verificarne l’esito.</Typography>,
            actions: <Button variant={"contained"} color="primary" onClick={() => handleChiudiClick()}>Chiudi</Button>,
            width: 'xs'
        }
    }

    const dialogContent = (steps[step].content)
    const dialogActions = (steps[step].actions)
    return (
        <GenericDialog open={props.open}
                       handleDialogCloseButton={() => props.setIsInviaNuovoEmailOpen(false)}
                       handleDialogClose={() => props.setIsInviaNuovoEmailOpen(false)}
                       dialogContent={dialogContent}
                       dialogActions={dialogActions}
                       dialogWidth={steps[step].width ?? "md"}>
            <Typography variant='h5'>{steps[step].title}</Typography>
        </GenericDialog>
    )
}

InviaNuovoEmailDialgo.propTypes = {
    open: PropTypes.bool,
    setIsInviaNuovoEmailOpen: PropTypes.func,
    selectedRows: PropTypes.array
}

export default InviaNuovoEmailDialgo;
